import { Routes } from '@angular/router';
import { profileResolver } from './resolvers';
import { authGuard } from '@app-auth';
import { profileGuard } from './guards';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [profileGuard],
    children: [
      {
        path: '',
        canActivate: [authGuard],
        loadChildren: () => import('./pages').then((r) => r.PAGES_ROUTES),
      },
    ],
  },
  {
    // Static OAuth callback registered in the Meta app dashboard. Kept at the
    // app root (not org-scoped) so the redirectUri is a fixed URL.
    path: 'social/callback',
    canActivate: [authGuard],
    resolve: {
      profile: profileResolver,
    },
    loadComponent: () =>
      import(
        './pages/components/social-hub/social-callback.component'
      ).then((c) => c.SocialCallbackComponent),
  },
  {
    // Backend OAuth callback redirects here after Gmail, Outlook or Exchange
    // consent. Kept at the app root so the URL does not depend on an org id.
    path: 'email/callback',
    canActivate: [authGuard],
    resolve: {
      profile: profileResolver,
    },
    loadComponent: () =>
      import('./pages/components/email/email-callback.component').then(
        (c) => c.EmailCallbackComponent,
      ),
  },
  {
    path: 'auth',
    resolve: {
      profile: profileResolver, // just to check if the user is logged-in
    },
    loadChildren: () => import('@app-auth').then((r) => r.AUTH_ROUTES),
  },
  // ...(environment.prod
  //   ? []
  //   : [
  //       {
  //         path: 'playground',
  //         loadChildren: () =>
  //           import('./playground/playground.routes').then(
  //             (r) => r.PLAYGROUND_ROUTES,
  //           ),
  //       },
  //     ]),
  {
    path: 'playground',
    loadChildren: () =>
      import('./playground/playground.routes').then((r) => r.PLAYGROUND_ROUTES),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
